
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPaginatedVideos } from "../../features/pagination/paginationSlice";
import { fetchVideos } from "../../features/videos/videosSlice";

export default function Number({index}) {
    const [flag, setFlag] = useState(false);
    const dispatch = useDispatch();

    const { tags, search, author } = useSelector((state) => state.filter);
    
    const numberHandler = (index) => {
        if(flag){
            setFlag(false)
        }else{
            setFlag(true)
        }
        dispatch(fetchPaginatedVideos({ tags, search, author, index }));
        dispatch(fetchVideos({ tags, search, author, index }));
    }

    const style = flag
    ? "bg-blue-600 text-white px-4 py-1 rounded-full cursor-pointer"
    : "bg-blue-100 text-white px-4 py-1 rounded-full cursor-pointer";

    return <div className={style} onClick={() => numberHandler(index)}>
        {index}
    </div>;
}
